import React from "react";
import { TableHeaders } from "../../plugins/table";
import { QueTypeAndWeightage } from "../../modal/college";
import { Delete, Edit } from "../../plugins/icons";

export const columns = (
	showModal: (row: QueTypeAndWeightage) => void,
	deleteClicked: (id: number) => void
): TableHeaders[] => {
	return [
		{
			id: "slno",
			headerText: "Sl No",
			sortable: true,
			resizable: true,
			rowElement: (row: QueTypeAndWeightage, index: number) => <div>{index + 1}</div>,
			maxWidth: 100,
			minWidth: 100,
			defaultWidth: 100,
		},
		{
			id: "quetype",
			headerText: "Question Type",
			sortable: true,
			resizable: true,
			rowElement: (row: QueTypeAndWeightage) => <div>{row.name}</div>,
			maxWidth: 100,
			minWidth: 100,
			defaultWidth: 100,
		},
		{
			id: "weightage",
			headerText: "Weightage",
			sortable: false,
			resizable: true,
			rowElement: (row: QueTypeAndWeightage) => <div>{row.weightage}</div>,
			maxWidth: 220,
			minWidth: 220,
			defaultWidth: 220,
		},
		{
			id: "selected",
			headerText: "Action",
			sortable: false,
			resizable: true,
			rowElement: (row: QueTypeAndWeightage) => (
				<div className="custom_secondary_form">
					<span title="Edit max_width_25" className="pr-1" onClick={() => showModal(row)}>
						<Edit />
					</span>
					<span title="Edit max_width_25" className="pl-1" onClick={() => deleteClicked(row.id)}>
						<Delete />
					</span>
				</div>
			),
			maxWidth: 100,
			minWidth: 100,
			defaultWidth: 100,
		},
	];
};
